// Carte Yalola « Activer les notifications ? » affichée AVANT le dialogue système (iOS : une seule chance par installation).
// Textes modifiables en admin (settings.push_primer.texts[field][lang]) ; vide → valeur par défaut ci-dessous.
export const PUSH_PRIMER_EVENT = "yalola:push-primer";
export const PUSH_PRIMER_LATER_KEY = "yalola.push_primer_later";
export const PUSH_PRIMER_DEFAULT_LATER_DAYS = 3;

export const PUSH_PRIMER_DEFAULTS = {
  title: { fr: "Activer les notifications ?", en: "Turn on notifications?", es: "¿Activar las notificaciones?", pt: "Ativar as notificações?" },
  body: {
    fr: "Sois prévenu(e) quand quelqu'un répond à ta publication, réagit ou commence à te suivre. Tu pourras changer d'avis à tout moment dans les réglages.",
    en: "Get notified when someone replies to your post, reacts or starts following you. You can change this anytime in Settings.",
    es: "Recibe un aviso cuando alguien responda a tu publicación, reaccione o empiece a seguirte. Puedes cambiarlo en cualquier momento en los ajustes.",
    pt: "Recebe um aviso quando alguém responder à tua publicação, reagir ou começar a seguir-te. Podes mudar isso a qualquer momento nas definições.",
  },
  cta: { fr: "Activer les notifications", en: "Turn on notifications", es: "Activar notificaciones", pt: "Ativar notificações" },
  later: { fr: "Plus tard", en: "Not now", es: "Más tarde", pt: "Mais tarde" },
};

export const primerText = (settings, field, lang) => {
  const code = String(lang || "fr").slice(0, 2);
  const custom = settings?.push_primer?.texts?.[field]?.[code];
  if (typeof custom === "string" && custom.trim()) return custom.trim();
  const d = PUSH_PRIMER_DEFAULTS[field] || {};
  return d[code] || d.fr || "";
};

// iOS : activée par défaut ; Android : désactivée par défaut (flux 1.5.6 inchangé tant que l'admin ne l'active pas).
export const primerEnabled = (settings, platform) => {
  const pp = settings?.push_primer || {};
  if (platform === "ios") return pp.ios_enabled !== false;
  if (platform === "android") return pp.android_enabled === true;
  return false;
};

export const primerLaterDays = (settings) => {
  const n = Number(settings?.push_primer?.later_days);
  return Number.isFinite(n) && n >= 1 ? Math.min(30, Math.floor(n)) : PUSH_PRIMER_DEFAULT_LATER_DAYS;
};

export const snoozePushPrimer = (storage = globalThis.localStorage) => {
  try { storage?.setItem(PUSH_PRIMER_LATER_KEY, new Date().toISOString()); } catch { /* stockage indisponible */ }
};

export const primerSnoozed = (settings, storage = globalThis.localStorage) => {
  try {
    const at = Date.parse(storage?.getItem(PUSH_PRIMER_LATER_KEY) || "");
    if (!Number.isFinite(at)) return false;
    return Date.now() - at < primerLaterDays(settings) * 86_400_000;
  } catch { return false; }
};
